export const SIGNPASSMOCK = {
  uinfin: "S6005051A",
  name: {
    lastupdated: "2025-05-08",
    source: "1",
    classification: "C",
    value: "MR MYINFO A"
  },
  nationality: {
    lastupdated: "2025-05-08",
    code: "SG",
    source: "1",
    classification: "C",
    desc: "SINGAPORE CITIZEN"
  },
  dob: {
    lastupdated: "2025-05-08",
    source: "1",
    classification: "C",
    value: "1967-11-13"
  },
  email: {
    lastupdated: "2025-05-08",
    source: "4",
    classification: "C",
    value: "myinfotesting@gmail.com"
  },
  mobileno: {
    lastupdated: "2025-05-08",
    source: "4",
    classification: "C",
    areacode: {
      value: "65"
    },
    prefix: {
      value: "+"
    },
    nbr: {
      value: "97399245"
    }
  },
  regadd: {
    country: {
      code: "SG",
      desc: "SINGAPORE"
    },
    unit: {
      value: "367"
    },
    street: {
      value: "Jalan Hitam Manis"
    },
    lastupdated: "2025-05-08",
    block: {
      value: "127"
    },
    source: "1",
    postal: {
      value: "278522"
    },
    classification: "C",
    floor: {
      value: "08"
    },
    type: "SG",
    building: {
      value: ""
    }
  },
  passtype: {
    lastupdated: "2025-05-08",
    code: "",
    source: "3",
    classification: "C",
    desc: ""
  },
  passexpirydate: {
    lastupdated: "2025-05-08",
    source: "3",
    classification: "C",
    value: ""
  },
  myinfo_log_id: "6a4221052f4c16cbadf9d215"
};
